import { ETrackingEventType } from "./tracking-event";

export enum EUserFirstStep {
  PROFILE_COMPLETED = 'PROFILE_COMPLETED',
  CLASS_SCHEDULED = 'CLASS_SCHEDULED',
  TASK_COMPLETED = 'TASK_COMPLETED',
  QUIZ_COMPLETED = 'QUIZ_COMPLETED',
  INTRODUCTION_VIEWED = 'INTRODUCTION_VIEWED',
  ACTIVITY_COMPLETED = 'ACTIVITY_COMPLETED'
} 

export const TRACKING_EVENT_TO_USER_FIRST_STEP_MAP: Record<ETrackingEventType, EUserFirstStep> = {
  [ETrackingEventType.PROFILE_COMPLETED]: EUserFirstStep.PROFILE_COMPLETED,
  [ETrackingEventType.LIVE_CLASS_ADDED]: EUserFirstStep.CLASS_SCHEDULED,
  [ETrackingEventType.PLANIFICATION_ACTIVITY_COMPLETED]: EUserFirstStep.TASK_COMPLETED,
  [ETrackingEventType.QUIZ_COMPLETED]: EUserFirstStep.QUIZ_COMPLETED,
  [ETrackingEventType.INTRODUCTION_COMPLETED]: EUserFirstStep.INTRODUCTION_VIEWED,
  [ETrackingEventType.ACTIVITY_COMPLETED]: EUserFirstStep.ACTIVITY_COMPLETED
};